import "./App.css";
import useUser from "./App/useUser";
import Login from "./Login";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import FillQuestionary from "./FillQuestionary";
import { Questionaries } from "./Questionaries";
import Summary from "./Summary";
import QuestionarySummary from "./QuestionarySummary";
import { AuditSectionsManager } from "./AuditSectionsManager";
import { QuestionarySectionsManager } from "./QuestionarySectionsManager";
import PolicyTypesManager from "./PolicyTypesManager";
import QuestionaryTypesManager from "./QuestionaryTypesManager";
import ExternalRegistration from "./ExternalRegistration";
import { Button } from "react-bootstrap";
import { Audits } from "./Audits";
import FillAudit from "./FillAudit";
import ConfirmationModalContextProvider from "../Helpers/modalConfirmationContext";
import ForgotPassword from "./Login/ForgotPassword";
import ResetPassword from "./Login/ResetPassword";
import { Companies } from "./Companies/Companies";
import { LoadingProvider } from "./App/LoadingContext";
import { Users } from "./Users/Users";

const AppContent = () => {
  const { user, setUser } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const hideNavbarPaths = ["/login", "/externalquestionary"];

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("questionaryId");
    localStorage.removeItem("questionaryEmail");
    localStorage.removeItem("auditId");
    navigate("/login");
  };

  const shouldHideNavbar = hideNavbarPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <>
      {!shouldHideNavbar && user && (
        <Navbar expand="lg" bg="primary" data-bs-theme="dark" className="ps-3">
          <Navbar.Brand href="/">
            <img
              src="legacy-simple-logo.png"
              width="60"
              className="d-inline-block align-top"
              alt="Legacy Seguros"
            />
          </Navbar.Brand>
          <Navbar.Text>LEGACY</Navbar.Text>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto ms-5">
              {user &&
                (user.role == "Administrador" ||
                  user.role == "Auditor" ||
                  user.role == "Externo") && (
                  <Nav.Link href="Questionary">Cuestionarios</Nav.Link>
                )}

              {user && user.role == "Auditor" && (
                <>
                  <Nav.Link href="Audit">Auditorías</Nav.Link>
                </>
              )}

              {user && user.role == "Administrador" && (
                <>
                  {/* Left-side navigation */}
                  <Nav.Link href="Audit">Auditorías</Nav.Link>
                  <NavDropdown title="Administrar" id="basic-nav-dropdown">
                    <NavDropdown.Item href="AuditTypeManager">
                      Tipos de Auditoría
                    </NavDropdown.Item>
                    <NavDropdown.Item href="AuditSectionsManager">
                      Auditorías
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="QuestionaryTypeManager">
                      Tipos de Cuestionario
                    </NavDropdown.Item>
                    <NavDropdown.Item href="QuestionarySectionsManager">
                      Cuestionarios
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="Companies">
                      Compañías
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="Users">Usuarios</NavDropdown.Item>
                  </NavDropdown>
                </>
              )}
            </Nav>

            {/* Right side - User info and logout */}
            <Nav className="ms-auto pe-3 align-items-center">
              <div className="d-flex align-items-center me-3">
                <i className="bi bi-person-circle fs-5 text-light me-2"></i>
                <Navbar.Text className="text-light">
                  {user.name || user.userName}
                </Navbar.Text>
              </div>
              <Button
                variant="link"
                onClick={handleLogout}
                className="text-light p-1"
                title="Cerrar sesión"
              >
                <i className="bi bi-box-arrow-right fs-5"></i>
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      )}

      <Routes>
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route
          path="externalquestionary/:questionaryId"
          element={
            <ExternalRegistration setUser={setUser}></ExternalRegistration>
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {user && user.role == "Externo" && (
          <>
            <Route
              path="FillQuestionary"
              element={<FillQuestionary></FillQuestionary>}
            ></Route>
            <Route
              path="Questionary"
              element={
                <ConfirmationModalContextProvider>
                  <Questionaries userId={user.id}></Questionaries>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route
              path="QuestionarySummary"
              element={<QuestionarySummary></QuestionarySummary>}
            ></Route>
          </>
        )}

        {user && user.role == "Auditor" && (
          <>
            <Route
              path="FillQuestionary"
              element={<FillQuestionary></FillQuestionary>}
            ></Route>
            <Route
              path="Questionary"
              element={
                <ConfirmationModalContextProvider>
                  <Questionaries userId={user.id}></Questionaries>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route
              path="Audit"
              element={
                <ConfirmationModalContextProvider>
                  <Audits userId={user.id}></Audits>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route path="FillAudit" element={<FillAudit></FillAudit>}></Route>
            <Route path="Summary" element={<Summary></Summary>}></Route>
            <Route
              path="QuestionarySummary"
              element={<QuestionarySummary></QuestionarySummary>}
            ></Route>
          </>
        )}

        {user && user.role == "Administrador" && (
          <>
            <Route
              path="FillQuestionary"
              element={<FillQuestionary></FillQuestionary>}
            ></Route>
            <Route
              path="Questionary"
              element={
                <ConfirmationModalContextProvider>
                  <Questionaries userId={user.id}></Questionaries>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route
              path="Audit"
              element={
                <ConfirmationModalContextProvider>
                  <Audits userId={user.id}></Audits>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route path="FillAudit" element={<FillAudit></FillAudit>}></Route>
            <Route path="Summary" element={<Summary></Summary>}></Route>
            <Route
              path="QuestionarySummary"
              element={<QuestionarySummary></QuestionarySummary>}
            ></Route>
            <Route
              path="AuditSectionsManager/*"
              element={
                <ConfirmationModalContextProvider>
                  <AuditSectionsManager></AuditSectionsManager>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route
              path="QuestionarySectionsManager/*"
              element={
                <ConfirmationModalContextProvider>
                  <QuestionarySectionsManager></QuestionarySectionsManager>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route
              path="AuditTypeManager"
              element={
                <ConfirmationModalContextProvider>
                  <PolicyTypesManager></PolicyTypesManager>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route
              path="QuestionaryTypeManager"
              element={
                <ConfirmationModalContextProvider>
                  <QuestionaryTypesManager></QuestionaryTypesManager>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route
              path="Companies"
              element={
                <ConfirmationModalContextProvider>
                  <Companies></Companies>
                </ConfirmationModalContextProvider>
              }
            ></Route>
            <Route
              path="Users"
              element={
                <ConfirmationModalContextProvider>
                  <Users></Users>
                </ConfirmationModalContextProvider>
              }
            />
          </>
        )}

        {/* Redirect to login for unauthorized access */}
        <Route
          path="*"
          element={user ? <Navigate to="/" /> : <Login setUser={setUser} />}
        />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <LoadingProvider>
      <AppContent />
    </LoadingProvider>
  );
};

export default App;
